import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { AlertTriangle, Download, FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import { agentApi } from '../agentApi';

export const fileFormatOf = (file) => String(file?.format || String(file?.filename || '').split('.').pop() || '').toLowerCase();

/** A file the agent exported: name, size, a personal-data flag and an authenticated download. */
function FileCard({ file, compact = false }) {
  const [busy, setBusy] = useState(false);
  if (!file?.fileId) return null;

  const format = fileFormatOf(file);
  const Icon = format === 'pdf' ? FileText : FileSpreadsheet;
  const personal = file.containsPersonalData === true || file.personalData === true;

  const download = async () => {
    setBusy(true);
    try {
      await agentApi.downloadFile(file.fileId, file.filename);
    } catch (error) {
      toast.error(error.message || 'Download failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`dagent-file${compact ? ' dagent-file--compact' : ''}`}>
      <span className={`dagent-file__icon dagent-file__icon--${format}`}>
        <Icon size={compact ? 15 : 18} aria-hidden="true" />
      </span>
      <div className="dagent-file__main">
        <div className="dagent-file__name" title={file.filename}>
          {file.filename}
        </div>
        <div className="dagent-file__meta">
          {format.toUpperCase()}
          {typeof file.rows === 'number' ? ` · ${file.rows} ${file.rows === 1 ? 'row' : 'rows'}` : ''}
          {file.size ? ` · ${file.size}` : ''}
        </div>
      </div>
      {personal && (
        <span className="dagent-chip dagent-chip--warn" title="Contains guest personal data">
          <AlertTriangle size={11} aria-hidden="true" /> Personal data
        </span>
      )}
      <button type="button" className="dagent-btn dagent-btn--ghost dagent-btn--sm" onClick={download} disabled={busy} aria-label={`Download ${file.filename}`}>
        {busy ? <Loader2 size={13} className="dagent-spin" aria-hidden="true" /> : <Download size={13} aria-hidden="true" />}
        {!compact && ' Download'}
      </button>
    </div>
  );
}

export default FileCard;
